import { useMutation, useQueryClient } from '@tanstack/react-query';
import { consentKeys, consentOptions } from '../../constants/consents';
export function useConsentActions() {
    const queryClient = useQueryClient();
    const getConsents = async (filter) => {
        return await queryClient.fetchQuery(consentOptions.get(filter));
    };
    const invalidateConsents = () => {
        queryClient.invalidateQueries({ queryKey: consentKeys.all });
    };
    const acceptMutation = useMutation({ ...consentOptions.accept(), onSuccess: invalidateConsents });
    return {
        getConsents,
        acceptConsent: acceptMutation.mutateAsync,
        savingConsents: acceptMutation.isPending,
    };
}
